<script>
  import { imgSrc } from '$client';
  export let data;
  $: item = data;
</script>

<li>
  <svelte:element
    this={item.achievement.data ? 'a' : 'div'}
    href={imgSrc(item.achievement.data?.attributes.url)}
    target="_blank"
    rel="nofollow">
    <img
      loading="lazy"
      itemprop="image"
      width="64"
      height="60"
      src={imgSrc(item.img.data.attributes.url)}
      alt={item.img.data.attributes.alternativeText} />
    <h3>{item.header}</h3>
    {#if item.description}
      <p class="achieve-desc" title={item.description}>{item.description}</p>
    {/if}
    {#if item.about}
      <p class="achieve-about" title={item.about}>{item.about}</p>
    {/if}
    {#if item.achievement.data}
      <span>Смотреть награду</span>
    {/if}
  </svelte:element>
</li>

<style lang="scss">
  a,
  div {
    display: contents;
  }

  a {
    cursor: pointer;
  }

  p {
    line-height: 15.6px;
  }

  li {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    justify-content: flex-start;
    padding-top: 10px;
    transition: transform 0.25s;

    &::before {
      position: absolute;
      top: 0;
      z-index: 1;
      display: block;
      width: 100%;
      height: 100%;
      background-image: url('https://admin.uberi.pro/uploads/Achievement_b7bb7299e1.svg');
      background-repeat: no-repeat;
      background-position: center top;
      content: '';
    }

    &:hover {
      span {
        opacity: 1;
      }

      &:has(.achieve-about) h3 {
        display: none;
      }

      &:has(.achieve-about) .achieve-desc {
        display: none;
      }

      .achieve-about {
        display: -webkit-box;
      }
    }

    h3,
    p,
    span,
    img {
      z-index: 2;
      text-align: center;
      margin-inline: 16px;
    }

    img {
      position: relative;
      top: 20px;
      margin-bottom: 20px;
    }

    h3 {
      color: #fff;
      font-weight: 800;
      font-size: 18px;
      font-family: Vela Sans;
    }

    .achieve-desc {
      color: #fffc;
      font-weight: 600;
      font-size: 12px;
      font-family: Vela Sans;
      text-align: center;
    }

    .achieve-about {
      display: none;
      overflow: hidden;
      color: #fffc;
      font-weight: 500;
      font-size: 14px;
      font-family: Vela Sans;
      white-space: normal;
      text-align: center;
      text-overflow: ellipsis;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }

    span {
      display: inline-flex;
      gap: 4px;
      align-items: center;
      justify-content: center;
      padding: 2px 8px;
      color: #fff;
      font-weight: 500;
      font-size: 12px;
      font-family: Vela Sans;
      background-color: #fff3;
      border-radius: 20px;
      opacity: 0;
      transition: opacity 0.15s linear;

      &::after {
        position: relative;
        top: 1.5px;
        display: block;
        width: 8px;
        height: 12px;
        background-image: url('https://admin.uberi.pro/uploads/Open_Achieve_5a4f57ec76.svg');
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
        content: '';
      }
    }

    @media only screen and (max-width: 1250px) {
      h3 {
        font-size: 16px !important;
      }

      p {
        font-size: 14px;
      }

      h3,
      p {
        margin-inline: 12px;
      }
    }

    @media only screen and (max-width: 991.98px) {
      p {
        font-size: 13px !important;
      }

      span {
        opacity: 1;
      }

      &:has(.achieve-about) h3 {
        display: block !important;
      }

      &:has(.achieve-about) .achieve-desc {
        display: block !important;
      }

      .achieve-about {
        display: none !important;
      }
    }

    @media only screen and (max-width: 767.98px) {
      h3 {
        font-size: 14px !important;
      }

      p {
        font-size: 12px !important;
      }

      h3,
      p {
        margin-inline: 8px;
      }
    }

    @media only screen and (max-width: 550.98px) {
      h3,
      p {
        margin-inline: 4px;
      }
    }
  }
</style>
